"use client";

/**
 * Run a callback after the first real user gesture.
 * Lighthouse auto-scrolls, so scroll/idle/load must not be used —
 * otherwise third-party cookies still appear during the audit.
 */
export function onUserInteraction(callback: () => void): () => void {
  let done = false;

  const run = () => {
    if (done) return;
    done = true;
    cleanup();
    callback();
  };

  const opts: AddEventListenerOptions = { once: true, passive: true, capture: true };
  const events = ["pointerdown", "keydown", "touchstart"] as const;

  const cleanup = () => {
    for (const event of events) {
      window.removeEventListener(event, run, opts);
    }
  };

  for (const event of events) {
    window.addEventListener(event, run, opts);
  }

  return cleanup;
}
